import Parse from 'modules/parse'

export default function run (name, params, callback) {
  if (typeof params === 'function') {
    callback = params
    params = {}
  }

  Parse.Cloud.run(name, params, {
    success: (results) => {
      callback(null, results)
    },
    error: (error) => {
      callback(error)
    }
  })
}



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/modules/run.js